export default [
    {
        name: '身份证',
        id: 1
    },
    {
        name: '护照',
        id: 2
    },
    // {
    //     name: '港澳通行证',
    //     id: 3
    // },
    
]